<span class="font-medium-title-large">Bereich bearbeiten</span>

<form [formGroup]="form" class="align-self-stretch flex-c gap-16">
  <div class="flex-r gap-16">
    <div class="input-simple flex-1-1-0">
      <label for="name" class="input-label"> Name* </label>
      <input
        type="text"
        id="name"
        name="name"
        class="input-field"
        placeholder="Name des Bereichs"
        formControlName="name" />
      <app-error-message [formField]="form.get('name')"></app-error-message>
    </div>
  </div>

  <div class="flex-r gap-16">
    <div class="input-simple flex-1-1-0">
      <label for="description" class="input-label">
        Beschreibung
        <span class="char-count">{{ getCharacterCount() }}</span>
      </label>
      <textarea
        id="description"
        name="description"
        class="input-field"
        rows="4"
        placeholder="Beschreibung des Bereichs"
        formControlName="description"></textarea>
      <app-error-message
        [formField]="form.get('description')"></app-error-message>
    </div>
  </div>

  <!-- Image Upload Section -->
  <div class="input-picture">
    <label class="input-label">Bereichsbild</label>
    <div class="add-picture">
      <div
        class="upload-area cursor-pointer"
        [style.background-image]="
          selectedImage ? 'url(' + selectedImage + ')' : ''
        "
        [style.background-size]="'cover'"
        [style.background-position]="'center'"
        (click)="handleImageUpload()">
        <button type="button" class="circle-xsmall border-none">
          <div class="circle-icon">
            <i class="fa-regular fa-plus"></i>
          </div>
        </button>
      </div>
      <div class="subtitle">Empfohlenes Format: 1:1, mind. 400x400px</div>
    </div>
    <input
      type="file"
      #fileInput
      accept="image/*"
      (change)="onFileSelected($event)"
      style="display: none" />
  </div>
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-times"></i>
      </div>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    class="inwi-icon-text-button-large-primary"
    (click)="onSave()"
    [disabled]="form.invalid || isLoading">
    <div class="button-content">
      <div class="button-icon">
        <i
          class="fa-regular"
          [ngClass]="isLoading ? 'fa-rotate' : 'fa-check'"></i>
      </div>
      <div class="button-text">
        {{ isLoading ? 'Wird gespeichert...' : 'Speichern' }}
      </div>
    </div>
  </button>
</div>
